import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {ApiConnectService} from './api-connect.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {OperatingStandardComponent} from '../content-page/operating-standard/operating-standard.component';
import {NotificationsService} from './notifications.service';


@Injectable()
export class OperatingStandardService {
  private operatingStandsNotificationCount = 0;
  private operatingStandsNotification: any;


  // Сервис при определенных действиях проверяет есть ли новые стандарты и
  // обновляет свою переменную числа уведомлений;
  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private notificationsService: NotificationsService) {
  }

  // UPDATE NOTIFICATION COUNT NUMBER;
  public notificationCountManager(count) {
    if (Number(count) !== this.operatingStandsNotificationCount) {
      if ((Number(count) === Number(0) && this.operatingStandsNotificationCount !== Number(0))
        || (Number(count) !== Number(0) && this.operatingStandsNotificationCount === Number(0))) {
        this.notificationsService.getNearNotificationFromAPI();
      }
      this.operatingStandsNotificationCount = Number(count);
    }
  }

  public getOperatingStandsNotificationsAPITemp() {
    return this.http.get(this.apiURL.getNotifications, {observe: 'response'});
  }

  public getGeneralNoitify(id) {
    return this.http.get(this.apiURL.getGeneralNotification + id, {observe: 'response'});
  }

  public getSuggestionNotificationsHistory(page: number = 0, size: number = 15, viewed: any = null) {
    const params = this.createNotificationHistoryParams(page, size, viewed);
    return this.http.get(this.apiURL.getSuggestionNotificationsHistory, {observe: 'response', params: params});
  }

  public getGeneralNotificationsHistory(page: number = 0, size: number = 15, viewed: any = null) {
    const params = this.createNotificationHistoryParams(page, size, viewed);
    return this.http.get(this.apiURL.getGeneralNotificationsHistory, {observe: 'response', params: params});
  }


  public getOperatingStandsNotificationList() {
    return this.operatingStandsNotification;
  }

  public getOperatingStandsNotifications() {
    return this.operatingStandsNotificationCount;
  }

  private setOperatingStandsNotifications(count) {
    this.operatingStandsNotificationCount = count;
  }

  private createNotificationHistoryParams(page: number, size: number, viewed: any): HttpParams {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size));

    if (viewed !== null && viewed !== undefined) {
      params = params.set('viewed', String(viewed));
    }

    return params;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/operating-standard.service.ts